<template>
  <div class="container">
    <div class="homeView my-1">
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <div
          id="breadcrumbsPropagate"
          class="row breadcrumbs"
        >
          <div class="col-12 col-md-7 mb-2">
            <ul
              class="breadcrumbs d-flex align-items-center pl-1"
              style=";"
            >
              <li>
                <router-link
                  :to="{ name: 'home' }"
                  class="link font-size16-be-vietnam text-dark-3"
                ><feather-icon
                    icon="HomeIcon"
                    width="22px"
                    height="22px"
                  /> </router-link>
              </li>
              <span class="icon" />
              <li
                v-for="(item, index) in itemsData.category_list"
                :key="index"
                class="li_category"
              >
                <router-link
                  :to="{ name: 'home-category-propate-box', params: { slug: item.slug } }"
                  class="link font-size16-be-vietnam font-weight-500"
                > {{ item.name }} </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div
          id="contentPropagate"
          class="row"
        >
          <div class="col-12 col-md-8">
            <div class="card shadow-none mb-1">
              <!-- <div class="card-header pl-1">
                <ul
                  class="breadcrumbs d-flex align-items-center pl-0"
                  style="list-style-type: none;"
                >
                  <li> <feather-icon icon="HomeIcon" /></li>
                  <span class="icon" />
                  <li
                    v-for="(item, index) in itemsData.category_list"
                    :key="index"
                    style="padding-left: 10px;"
                  >
                    <router-link
                      :to="{ name: 'home-category-propate-box', params: { slug: item.slug } }"
                      class="link font-size16-be-vietnam"
                      style=" color:#0B438D !important"
                    > {{ item.name }} </router-link>
                  </li>
                </ul>

              </div> -->
              <div
                id="printArticle"
                class="card-body p-1 view"
                :class="itemsData.is_read ? '' : 'unselectable'"
                :oncontextmenu="itemsData.is_read ? 'return true' : 'return false'"
                :onselectstart="itemsData.is_read ? 'return true' : 'return false'"
              >
                <h1
                  class="font-be-vietnam title"
                  style=""
                >{{ itemsData.title }}</h1>
                <div
                  class="detail"
                  v-html="itemsData.content"
                />
              </div>
            </div>
            <!-- Bình luận -->
            <!-- <comment :article_id="itemsData.id" /> -->
          </div>
          <div class="col-12 col-md-4">
            <div
              class="card author shadow-none pt-0"
              :class="itemsData.is_read ? '' : 'unselectable'"
              :oncontextmenu="itemsData.is_read ? 'return true' : 'return false'"
              :onselectstart="itemsData.is_read ? 'return true' : 'return false'"
            >
              <div class="card-body p-1">
                <ul class="font-be-vietnam">
                  <li class="font-be-vietnam">
                    <!-- Thời gian đăng: <strong>{{ author.created_at ? moment.unix(author.created_at).format('DD/MM/YYYY, hh:mm') : moment.unix(itemsData.created_at).format('DD/MM/YYYY') }}</strong> -->
                    Thời gian đăng: <strong>{{ itemsData.show_view_propagate_published_at }}</strong>
                  </li>
                  <li class="font-be-vietnam">
                    Đơn vị làm tin: <strong>{{ (author.unit) ? author.unit : author.department_code }}</strong>
                  </li>
                  <li class="font-be-vietnam">
                    Tác giả: <strong>{{ renderAuthor(coAuthor, author) }}</strong>
                  </li>
                  <hr>
                  <li
                    v-if="attached_files.length > 0"
                    class="file d-flex flex-column"
                  >
                    <p class="mb-0 font-be-vietnam">
                      File đính kèm
                    </p>
                    <a
                      v-for="(file, index) in attached_files"
                      :key="index"
                      href="javascript:void(0)"
                      style=""
                      class="a_downloadItem"
                      @click="dowload(file)"
                    > {{ file.name }}.{{ file.extension }} <span
                        classs="iconDownloadItem"
                        style=""
                      ><feather-icon icon="DownloadIcon" /></span> </a>
                  </li>

                </ul>

              </div>
            </div>
          </div>
        </div>
        <div
          v-if="dataRelate.length"
          class="row relate"
        >
          <div class="col-12 col-md-12 font-be-vietnam">
            <div class="card shadow-none">
              <div class="card-header">

                <h3 class="card-title fw-bolder">
                  <!-- <feather-icon icon="FileTextIcon" />  -->
                  <span class="iconNews2" /> <span class="font-weight-600 font-size20-be-vietnam">Chỉ đạo thông tin khác</span>
                </h3>
              </div>
              <div class="card-body p-1">
                <ul class="new-list">
                  <li
                    v-for="(item, index) in dataRelate"
                    :key="index"
                  >
                    <h3 class="news-title d-flex">
                      <span
                        class="icon"
                        style=""
                      />
                      <router-link
                        :to="{ name: 'home-view-propate-box', params: { id: item.id, slug: item.slug } }"
                        class="link font-size16-be-vietnam"
                      >
                        <b>{{ item.title }}</b> </router-link>
                    </h3>
                    <div class="news-icon d-flex flex-row pl-1">
                      <!-- <span
                        v-if="item.hot"
                        class="iconHot"
                      />
                      <span
                        v-for="(val, index) in item.content_type"
                        :key="index"
                        :class="`icon` + val"
                      /> -->
                      <span><feather-icon icon="PaperclipIcon" /> {{ timeago(item.published_at) }}</span>
                      <!-- <span
                        v-if="item.unit"
                        class="icon"
                        style="padding-left: 10px;"
                      />
                      <span
                        v-if="item.unit"
                        class="iconView"
                      />
                      <span v-if="item.unit">{{ item.unit }}</span> -->
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>
<script>
import {
  BCard,
  BOverlay,
  BCardBody,
  BRow,
  BCol,
  BButton,
  BTable,
  BPagination,
  BImg,
  BFormInput,
  BFormGroup,
} from 'bootstrap-vue';
import {
  ref, watch, computed, onMounted, onBeforeUnmount,
} from '@vue/composition-api';
import store from '@/store'
import { showToast, useRouter } from '@core/utils/utils';
import moment from 'moment';
import print from 'vue-print-nb'
import '@/libs/func'
import Comment from './partials/Comment.vue';

export default {
  components: {
    BCard,
    BOverlay,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BTable,
    BPagination,
    BImg,
    BFormInput,
    BFormGroup,
    Comment,
  },
  directives: {
    print,
  },
  data() {
    return {
      dataParent: [],
      moment,
    }
  },
  watch: {
    $route(to, from) {
      const home_id = to.params.id
      this.fetchData(home_id)
    },
  },
  setup(props, context) {
    const { route, router } = useRouter();

    const loading = ref(true)
    const total = ref(0)
    const itemsData = ref([]);
    const dataRelate = ref([])
    const attached_files = ref([])
    const content_files = ref([])
    const tags = ref([])
    const author = ref({})
    const coAuthor = ref([])
    const dataApproved = ref({})
    const dataCorrected = ref({})
    const all_file = ref([])
    const { id } = route.value.params;
    const fetchData = (id) => {
      store.dispatch('home/show', id)
        .then(response => {
          loading.value = false;
          const result = response.data;
          if (result.code == 200) {
            document.title = `${result.data.title} | CỔNG TIN TỨC ĐÀI TIẾNG NÓI VIỆT NAM`
            itemsData.value = result.data;
            dataRelate.value = result.data.relate
            attached_files.value = result.data.attached_files
            content_files.value = result.data.files
            tags.value = result.data.tags
            author.value = result.data.author
            coAuthor.value = result.data.co_author
            dataApproved.value = result.data.dataApproved
            dataCorrected.value = result.data.dataCorrected
            loadHtml(itemsData.value.content)
          }
        })
    }
    const loadHtml = (content) => {
      if (itemsData.value.is_read) {
        const regexp = /<img[^>]+src\s*=\s*['"]([^'"]+)['"][^>]*>/g;
        const regexp_video = /<video[^>]*>(.*?)<\/video>/g;
        const regexp_audio = /<audio[^>]*>(.*?)<\/audio>/g;
        const srcImg = content.match(regexp);
        const srcVideo = content.match(regexp_video)
        const srcAudio = content.match(regexp_audio)

        const listItems = [];
        if (srcImg) {
          listItems.push(...srcImg)
        }
        if (srcVideo) {
          listItems.push(...srcVideo);
        }
        if (srcAudio) {
          listItems.push(...srcAudio);
        }
        let html = content;
        if (listItems.length > 0) {
          listItems.forEach((element) => {
            const img = element.match(/src\s*=\s*['"]([^'"]+)['"]/)
            if (img[1]) {
              const image = img[1];
              let filename = image.split('/').pop().toLowerCase();
              let ext = filename.split('.').pop().toLowerCase();
              if (content_files.value.length > 0) {
                const file_item = {}
                content_files.value.map((item) => {
                  if (item.file == filename) {
                    filename = `${item.name}.${item.extension}`
                    ext = item.extension;
                  }
                })
              }
              const name = filename.replace(`.${ext}`, '')
              const tag_src = `<p class="mb-0 text-center"><a href="javascript:void(0)" class="btn btn-blue taive"  onClick="downloadFile(this)" dataname="${filename}" dataurl="${image}"><span class="icon_taive"></span></a></p>`;
              all_file.value.push({ full_path: image, name, extension: ext })
              html = html.replace(element, element + tag_src)
            }
          })
        }
        itemsData.value.content = html;
      }
    }

    fetchData(id)

    const scrollChange = (e) => {
      const curr = window.pageYOffset;
      window.addEventListener('scroll', () => {
        if (window.scrollY <= 20) {
          if (document.querySelector('#headerBanerCategory')) {
            document.querySelector('#headerBanerCategory').classList.remove('fixBanner');
          }
          if (document.querySelector('#headerBaner')) {
            document.querySelector('#headerBaner').classList.remove('fixBanner');
          }
        } else if (window.scrollY > 20) {
          if (document.querySelector('#headerBanerCategory')) {
            document.querySelector('#headerBanerCategory').classList.add('fixBanner');
          }
          if (document.querySelector('#headerBaner')) {
            document.querySelector('#headerBaner').classList.add('fixBanner');
          }
        }
      });
    }
    onMounted(() => {
      window.addEventListener('scroll', scrollChange);
    });
    onBeforeUnmount(() => {
      window.removeEventListener('scroll', scrollChange);
    });
    return {
      fetchData,
      itemsData,
      loading,
      total,
      dataRelate,
      attached_files,
      tags,
      author,
      coAuthor,
      dataCorrected,
      dataApproved,
      loadHtml,
      content_files,
      all_file,
    }
  },
  methods: {
    downloadAll(id) {
      if (this.all_file.length > 0) {
        store.dispatch('home/download', id).then(response => {
          const result = response.data;
          if (result.code == 200) {
            this.all_file.map((item) => {
              this.dowload(item)
            })
          } else {
            showToast(result.message)
          }
        })
      }
    },
    doCopy() {
      const content = this.itemsData.content.replace(/(<([^>]+)>)/ig, '');
      this.$copyText(content).then(() => {
        showToast('Copy nội dung thành công', { variant: 'success' })
      }, e => {
        showToast('Không thể copy nội dung')
      })
      return content
    },
    onReadArticle(id) {
      this.$swal({
        title: '',
        text: 'Bạn có muốn lấy tin này?',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          store.dispatch('home/read', id).then(response => {
            const result = response.data;
            if (result.code == 200) {
              this.itemsData.is_read = true;
              if (this.itemsData.unit) {
                // this.itemsData.unit = `${this.itemsData.unit},${result.data.unit}`
                this.itemsData.unit = this.renderPartOrUnit(this.itemsData.unit.split(','), result.data.unit);
              } else {
                // this.itemsData.unit = result.data.unit;
                this.itemsData.unit = this.renderPartOrUnit([], result.data.unit);
              }
              if (this.itemsData.depart_read) {
                this.itemsData.depart_read = this.renderPartOrUnit(this.itemsData.depart_read.split(','), result.data.department_code);
                // this.itemsData.depart_read = `${this.itemsData.depart_read},${result.data.department_code}`;
              } else {
                this.itemsData.depart_read = this.renderPartOrUnit([], result.data.department_code);
                // this.itemsData.depart_read = result.data.department_code
              }
              this.loadHtml(this.itemsData.content)
              showToast(result.message, { variant: 'success' })
            } else {
              showToast(result.message)
            }
          })
        }
      });
    },
    timeago(published_at) {
      const time = Math.floor(Date.now() / 1000) - published_at;
      if (time < 1) {
        return 'vừa xong';
      }
      const a = [
        { number: 31536000, name: 'năm' },
        { number: 2592000, name: 'tháng' },
        { number: 86400, name: 'ngày' },
        { number: 3600, name: 'giờ' },
        { number: 60, name: 'phút' },
        { number: 1, name: 'giây' },
      ]
      for (let i = 0; i < a.length; i++) {
        const d = time / a[i].number
        if (d >= 1) {
          const r = Math.round(d);
          return `${r} ${a[i].name}`
        }
      }
    },
    iconView(content_type) {
      const dataType = JSON.parse(content_type);
      const data = [];
      dataType.forEach(element => {
        if (element == 'news') {
          data.push('<span class="iconNews"></span>')
        } else if (element == 'video') {
          data.push('<span class="iconVideo"></span>')
        } else if (element == 'audio') {
          data.push('<span class="iconAudio"></span>')
        } else if (element == 'photo') {
          data.push('<span class="iconImage"></span>')
        }
        return data;
      });
    },
    async dowload(file) {
      if (!this.itemsData.is_read) {
        return;
      }
      const name = `${file.name}.${file.extension}`;
      const url = file.file_path ? file.file_path : file.full_path;
      const data = await fetch(url)
      const blob = await data.blob()
      const objectUrl = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.setAttribute('href', objectUrl)
      link.setAttribute('download', name)
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    renderAuthor(data, author) {
      //  lọc cả các tác giả trùng với trong co_author
      // return 1;
      // const item = data.filter(t => t.user_id !== author.user_id);
      // return item.map(o => o.alias).join(';');
      // const item = data.filter(t => t.user_id !== author.user_id);

      // return Array.isArray(data) ? [...new Set(data.map(o => o.alias))].join(';') : '---';

      return [...new Set(data.map(o => o.alias))].join(';');
    },

    renderPartOrUnit(listArray, str) {
      if (listArray.includes(str)) {
        return listArray.join(',')
      }
      listArray.push(str);
      return listArray.join(',')
    },
  },
}
// export default vm;
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
